module.exports = __webpack_public_path__ + "img/teachers.596bf5b6.png";